import "./StandardMeetingsPanel.scss";

import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useStandardMeetingsPanel } from "providers";
import { useTranslations } from "providers";
import { useMeeting } from "providers";
import React from "react";

import { StandardMeetingsPanelFooter } from "./StandardMeetingsPanelFooter";
import { StandardMeetingsPanelForm } from "./StandardMeetingsPanelForm";
import { StandardMeetingsPanelPreview } from "./StandardMeetingsPanelPreview";

export const StandardMeetingsPanel: React.FC = () => {
  const i18n = useTranslations();
  const { meetingId } = useMeeting();
  const { isOpen, templateId, setTemplateId, closeStandardMeetingsPanel } = useStandardMeetingsPanel();

  if (!isOpen || !meetingId) {
    return null;
  }

  return (
    <SlidingPanel
      isOpen
      onClose={closeStandardMeetingsPanel}
      panelContainerClassName="standard-meetings-panel"
      size={65}
      header={<h1 className="pb-3">{i18n.StandardMeetingsPanel_Header}</h1>}
      footer={<StandardMeetingsPanelFooter />}
    >
      <>
        <div className="d-flex">
          <p className="description">{i18n.StandardMeetingsPanel_Description}</p>
        </div>
        <StandardMeetingsPanelForm templateId={templateId} setTemplateId={setTemplateId} />
        <StandardMeetingsPanelPreview templateId={templateId} meetingId={meetingId} />
      </>
    </SlidingPanel>
  );
};
